<template>
  <component :is="CurrentTab" :menu-feature="childMenuFeature">
    <template v-slot:tabs>
      <ListTab :tabs="tabs" :current-tab="CurrentTab" @change-tab="ChangeTab" />
    </template>
  </component>
</template>

<script>
import {
  ListModuleTab as ListTab
} from '@telexpress/vue-list-module';
import UserList from '@/components/Auth/User/UserList.vue';
import RoleList from '@/components/Auth/Role/RoleList.vue';

export default {
  components: {
    UserList,
    RoleList,
    ListTab
  },
  props: ['menuFeature'],
  data() {
    return {
      currentTab: null
    };
  },
  computed: {
    CurrentTab() {
      if ((this.currentTab || '') === '') {
        return this.tabs.length > 0 ? this.tabs[0].value : 'vue-auth-main';
      }
      return this.currentTab;
    },
    tabs() {
      const tabs = [];
      if (this.menuFeature.ManageUser) {
        tabs.push({
          value: 'UserList',
          text: this.$t('auth.userList')
        });
      }

      if (this.menuFeature.ManageRole) {
        tabs.push({
          value: 'RoleList',
          text: this.$t('auth.roleList')
        });
      }

      return tabs;
    },
    childMenuFeature() {
      switch (this.CurrentTab) {
        case 'UserList':
          return this.menuFeature.ManageUser;
        case 'RoleList':
          return this.menuFeature.ManageRole;
        default:
          return {};
      }
    }
  },
  methods: {
    ChangeTab(tab) {
      this.currentTab = tab;
    }
  }
};
</script>
